import { Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

import { BlockedPremiumFeatureModal } from '@/components';
import { COLOR } from '@/theme/colors';

import { Props } from './types';

export const InvoiceLimitReachedModal: React.FC<Props> = ({ onClose }) => {
    return (
        <BlockedPremiumFeatureModal
            description={t('PremiumPage:subscriptionPlans:premium:description')}
            info={
                <>
                    <Typography fontSize={12} color={COLOR.astronautBlue}>
                        {t('InvoicesPage:limitReachedModal:paragraph_1')}
                    </Typography>
                    <Typography fontSize={12} color={COLOR.astronautBlue}>
                        {t('InvoicesPage:limitReachedModal:paragraph_2')}
                    </Typography>
                </>
            }
            close={onClose}
        />
    );
};
